import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { PassengerSlot } from '../../types';
import { passengerSlotKindMeta } from '../../helpers/passengerSlotDisplay';

interface Props {
	slot: PassengerSlot;
	slotIndex: number;
	totalSlots: number;
	/** Texto debajo del título (ej. instrucción de búsqueda). */
	subtitle?: string;
}

export const PassengerSlotHeader = ({ slot, slotIndex, totalSlots, subtitle }: Props): JSX.Element => {
	const meta = passengerSlotKindMeta[slot.kind];

	return (
		<Box sx={{ mb: 2 }}>
			<Box display="flex" flexWrap="wrap" alignItems="center" gap={1} mb={0.5}>
				<Chip label={meta.chipLabel} color={meta.chipColor} size="small" />
				<Typography variant="caption" color="text.secondary">
					Pasajero {slotIndex + 1} de {totalSlots}
				</Typography>
			</Box>
			<Typography variant="subtitle1" fontWeight={700}>
				{slot.label}
			</Typography>
			{slot.kind === 'adult' && slotIndex === 0 && (
				<Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
					Pasajero principal de la orden
				</Typography>
			)}
			{subtitle && (
				<Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
					{subtitle}
				</Typography>
			)}
		</Box>
	);
};
